export default "__VITE_ASSET__CBmKxf53__"